// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dialog-footer.dialog-footer-actions {
  box-sizing: border-box;
  padding-top: 22px;
  padding-bottom: 35px;
}

.p-dialog-footer.dialog-footer-actions.dialog-footer-actions--department {
  padding-top: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/DialogFooter.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".p-dialog-footer.dialog-footer-actions {\n  box-sizing: border-box;\n  padding-top: 22px;\n  padding-bottom: 35px;\n}\n\n.p-dialog-footer.dialog-footer-actions.dialog-footer-actions--department {\n  padding-top: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
